const theme = {
  colors: {
    primary: '#027dbd',
    secondary: '#eb5f09',
    white: '#ffffff',
    black: '#000000',
    background: {
      '100': '#ffffff',
      '200': '#f3f4f8',
      '300': '#f0f1f6'
    },
    neutral: {
      '100': '#bdc0d8',
      '200': '#bcbfd7',
      '300': '#bec1d8',
      '400': '#545b65'
    },
    success: '#28a745',
    warning: '#ffc107',
    danger: '#dc3545',
    info: '#17a2b8'
  },
};

export default theme;
